import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "table-data-root" }
const _hoisted_2 = { class: "tableCornerRadiusForAudit bg-white table-card-shell" }
const _hoisted_3 = { class: "table-card-inner" }
const _hoisted_4 = { class: "table-container table-container-fit" }
const _hoisted_5 = { class: "table-header-wrap" }
const _hoisted_6 = { class: "table-header-row" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_9 = {
  key: 1,
  class: "flex"
}
const _hoisted_10 = { class: "cursor-pointer" }
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = { class: "table-body-scroll" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_17 = {
  key: 0,
  class: "my-1"
}
const _hoisted_18 = { class: "text-red-500" }
const _hoisted_19 = {
  key: 0,
  class: "error-text"
}
const _hoisted_20 = {
  key: 1,
  class: "error-text"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-red-500" }
const _hoisted_23 = {
  key: 0,
  class: "error-text"
}
const _hoisted_24 = {
  key: 1,
  class: "error-text"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "table-ellipsis" }
const _hoisted_27 = ["onMousemove"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "flex pl-4" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 4 }
const _hoisted_33 = { class: "table-ellipsis" }
const _hoisted_34 = ["onMousemove"]
const _hoisted_35 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", {
              class: "table-fit-card table-header-table",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'h-'+columnName,
                    style: _normalizeStyle(_ctx.columnStyle(columnName))
                  }, null, 4))
                }), 128))
              ]),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      key: columnName,
                      class: _normalizeClass([_ctx.getColumnHeadWidth(columnName), "bg-white capitalize resizable-th"]),
                      style: _normalizeStyle(_ctx.columnStyle(columnName)),
                      onClick: ($event: any) => (_ctx.onHeaderClick(columnName))
                    }, [
                      (columnName == 'deleteIcon')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getColumnLabel(columnName)), 1),
                            (_ctx.getColumnLabel(columnName) != '')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == columnName ? _ctx.classSort : 'opacity-50'])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ])),
                      _createElementVNode("span", {
                        class: "column-resize-handle",
                        onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, columnName)), ["stop","prevent"])
                      }, null, 40, _hoisted_11)
                    ], 14, _hoisted_7))
                  }), 128))
                ])
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", {
              class: "table-fit-card",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'b-'+columnName,
                    style: _normalizeStyle(_ctx.columnStyle(columnName))
                  }, null, 4))
                }), 128))
              ]),
              (_ctx.sortedData.length == 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createElementVNode("tr", _hoisted_14, [
                      _createElementVNode("td", {
                        class: "relative h-10",
                        colspan: _ctx.columnNames.size
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "flex justify-center" }, [
                          _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                        ], -1)
                      ]), 8, _hoisted_15)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row,
                        class: "cursor-pointer rowHeight"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: columnName,
                            onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doFalse())),
                            class: _normalizeClass(["cursor-pointer relative", _ctx.getColumnHeadWidth(columnName)]),
                            style: _normalizeStyle(_ctx.columnStyle(columnName))
                          }, [
                            (columnName == 'teamOwner')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_AutoComplete, {
                                    modelValue: row.teamOwner,
                                    "onUpdate:modelValue": ($event: any) => ((row.teamOwner) = $event),
                                    suggestions: _ctx.TeamOwnerOptions,
                                    onComplete: _ctx.asyncFind1,
                                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkAfterRequired('check'))),
                                    optionLabel: "label",
                                    optionValue: "value",
                                    forceSelection: true,
                                    placeholder: "TeamLeader",
                                    class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
                                        'p-invalid': _ctx.validationErrors[index]?.teamOwner || _ctx.validationErrors[index]?.sameAuditorAuditee,
                                    }])
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "onComplete", "class"]),
                                  _createElementVNode("div", _hoisted_18, [
                                    (_ctx.validationErrors[index]?.teamOwner)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                      : _createCommentVNode("", true),
                                    (_ctx.validationErrors[index]?.sameAuditorAuditee)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Team Owner and Reviewer cannot be the same"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (columnName == 'reviewer')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_AutoComplete, {
                                      modelValue: row.reviewer,
                                      "onUpdate:modelValue": ($event: any) => ((row.reviewer) = $event),
                                      suggestions: _ctx.reviewerOptions,
                                      onComplete: _ctx.asyncFind,
                                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkAfterRequired('check'))),
                                      optionLabel: "label",
                                      optionValue: "value",
                                      forceSelection: true,
                                      placeholder: "TeamLeader",
                                      class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
                                        'p-invalid': _ctx.validationErrors[index]?.reviewer || _ctx.validationErrors[index]?.sameAuditorAuditee
                                    }])
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "onComplete", "class"]),
                                    _createElementVNode("div", _hoisted_22, [
                                      (_ctx.validationErrors[index]?.reviewer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Required"))
                                        : _createCommentVNode("", true),
                                      (_ctx.validationErrors[index]?.sameAuditorAuditee)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Team Owner and Reviewer cannot be the same"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : (columnName=='entity'||columnName=='location')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", {
                                          onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'text'))
                                        }, _toDisplayString(_ctx.getLocationName(row[columnName])), 41, _hoisted_27)
                                      ]),
                                      (_ctx.pop == true && _ctx.sortedData[_ctx.tipIndex][columnName] == _ctx.tipText && _ctx.tipColumn == columnName && _ctx.tipIndex == index)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createVNode(_component_tool_tip, {
                                              columnName: columnName,
                                              tipText: _ctx.tipText,
                                              styling: _ctx.styling
                                            }, null, 8, ["columnName", "tipText", "styling"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (columnName == 'deleteIcon')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("img", {
                                            src: _imports_0,
                                            class: "h-5 cursor-pointer w-5 mx-2.5",
                                            onClick: ($event: any) => (_ctx.emitDeleteRowEvent(row))
                                          }, null, 8, _hoisted_31)
                                        ])
                                      ]))
                                    : (columnName=='team')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("div", {
                                              onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'text'))
                                            }, _toDisplayString(_ctx.getTeamName(row[columnName])), 41, _hoisted_34)
                                          ]),
                                          (_ctx.pop == true && _ctx.sortedData[_ctx.tipIndex][columnName] == _ctx.tipText && _ctx.tipColumn == columnName && _ctx.tipIndex == index)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createVNode(_component_tool_tip, {
                                                  columnName: columnName,
                                                  tipText: _ctx.tipText,
                                                  styling: _ctx.styling
                                                }, null, 8, ["columnName", "tipText", "styling"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                          ], 38))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
            ], 4)
          ])
        ]),
        _createVNode(_component_pagination, {
          dynamicPagination: _ctx.dynamicPagination,
          onCurrentPageUpdate: _ctx.paginationUpdations,
          entityId: _ctx.entityId,
          sortedData: _ctx.sortedData
        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "entityId", "sortedData"])
      ])
    ])
  ]))
}